import { render } from "./VoucherPrint.vue?vue&type=template&id=4e6705b6&scoped=true"
import script from "./VoucherPrint.vue?vue&type=script&lang=js"
export * from "./VoucherPrint.vue?vue&type=script&lang=js"

import "./VoucherPrint.vue?vue&type=style&index=0&id=4e6705b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6705b6"]])

export default __exports__